import React from 'react';
import PropTypes from 'prop-types';
import AvatarEditor from 'react-avatar-editor';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

import EditorControls from './EditorControls';
import ImageEditor from '../../../blocks/ImageEditor';
import Button from '../../../elements/Button';
import RangeSelector from '../../../elements/RangeSelector';
import FormLabel from '../../../elements/FormLabel';

const FullWdith = styled.div`
  width: 100%;
`;

class EditImage extends React.PureComponent {
  editorRef = React.createRef();

  state = {
    avatar: {
      scale: 1,
    },
  };

  _handleScale = (e) => {
    const scale = parseFloat(e.target.value);

    this.setState((prevState) => ({
      avatar: {
        ...prevState.avatar,
        scale,
      },
    }));
  };

  _handcleCancel = (e) => {
    e.preventDefault();
    const { _cancelHandler } = this.props;
    _cancelHandler(null);
  };

  _handleSubmit = (e) => {
    e.preventDefault();
    const { _submitHandler } = this.props;

    if (this.editorRef) {
      const canvas = this.editorRef.current.getImage();
      const imgData = canvas.toDataURL('image/jpeg', 1.0);

      _submitHandler(imgData);
    }
  };

  render() {
    const { imgFile, size } = this.props;
    const { avatar } = this.state;

    return (
      <ImageEditor>
        <ImageEditor.Image>
          <AvatarEditor
            ref={this.editorRef}
            image={imgFile}
            width={size}
            height={size}
            border={0}
            borderRadius={size / 2}
            color={[0, 0, 0, 0.45]}
            scale={parseFloat(avatar.scale)}
          />
        </ImageEditor.Image>
        <EditorControls>
          <FullWdith>
            <FormLabel>
              <FormattedMessage
                id="EditImage.zoomLabel"
                defaultMessage="Zoom:"
              />
              <RangeSelector
                onChange={this._handleScale}
                min="1"
                max="2"
                step="0.01"
                defaultValue="1"
              />
            </FormLabel>
          </FullWdith>
        </EditorControls>
        <EditorControls>
          <Button modifiers={['small']} onClick={this._handcleCancel}>
            <FormattedMessage
              id="EditImage.cancelBtn"
              defaultMessage="Cancel"
            />
          </Button>
          <Button modifiers={['primary', 'small']} onClick={this._handleSubmit}>
            <FormattedMessage
              id="EditImage.saveBtn"
              defaultMessage="Save"
            />
          </Button>
        </EditorControls>
      </ImageEditor>
    );
  }
}

EditImage.propTypes = {
  _cancelHandler: PropTypes.func.isRequired,
  _submitHandler: PropTypes.func.isRequired,
  imgFile: PropTypes.shape({}).isRequired,
  size: PropTypes.number.isRequired,
};

export default EditImage;
